/**
 * User: hella
 * Date: 6/22/14
 * Time: 3:11 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

var dibsConstants = require('bunsen/helpers/dibsConstants');

module.exports = {

    EMAIL: {
        //http://www.w3.org/TR/html5/forms.html#valid-e-mail-address
        FORMAT: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
        MAX_LENGTH: /^.{0,100}$/,
        FROM_NAME: /^.{0,50}$/
    },

    CURRENCY_REGEX_DEFAULT : {
        numFormat: /^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*?$/,
        zeroInput: /^0*(,[0-9]*?)*?(\.[0-9]*)?$/
    },
    CURRENCY_REGEX_EU: {
        numFormat: /^[+-]?[0-9]{1,3}(?:\.?[0-9]{3})*?$/,
        zeroInput: /^0*(\.[0-9]*)*?(,[0-9]*?)?$/
    },

    MSG_REGEX : /^(.|[\r\n]){0,2000}$/,

    CURRENCY_DEFAULT : dibsConstants.currency.codes.usd,
    CURRENCY_US      : dibsConstants.currency.codes.usd,
    CURRENCY_UK      : dibsConstants.currency.codes.gbp,
    CURRENCY_EU      : dibsConstants.currency.codes.eur,
    msgs: {
        // should move to static repo at some point
        numberFormat: 'Please enter a number in format '
    }

};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/modules/modalEmail/modalEmailConstants.js
// module id = 753
// module chunks = 4 7 12